import { render } from "./CleaningLogAddPage.vue?vue&type=template&id=db906a84&scoped=true"
import script from "./CleaningLogAddPage.vue?vue&type=script&lang=js"
export * from "./CleaningLogAddPage.vue?vue&type=script&lang=js"

import "./CleaningLogAddPage.vue?vue&type=style&index=0&id=db906a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db906a84"]])

export default __exports__